module.exports = __webpack_public_path__ + "img/p21.c47027a2.png";